import React from "react";

// ponytail: Improved footer with version, build, and copyright
const Footer = () => {
  return (
    <div className="footer-section">
      <div className="footer-content">
        <span className="footer-copyright">
          Copyright © {new Date().getFullYear()}{" "}
          <a href="#" style={{ color: "#01bff2", textDecoration: "none" }}>
            VedMG Technologies
          </a>
          . All Rights Reserved.
        </span>
        {/* <span className="footer-divider">|</span>
        <span className="footer-version">v1.0.0</span>
        <span className="footer-divider">|</span> */}
        {/* <span className="footer-build">Build {process.env.REACT_APP_ENV === "prod" ? "2026.07.23" : "DEV-2026.07.23"}</span> */}
      </div>
    </div>
  );
};

export default Footer;